module.exports = __webpack_public_path__ + "static/media/money-dollar.dc27f31c.svg";